/**
 * ********************************************************************
 * Calendar start date
 *  - contains useful calendar functions
 * ********************************************************************
 */
module.exports = {
    calendarStartDate: function () {
        var cdate = new Date(),
            cmonth = cdate.getMonth(),
            cyear = cdate.getFullYear();
        if (cmonth >= 10) {
            return (new Date(cyear+1, 2, 1)); // 1 march next year
        }
        if (cmonth <= 2) {
            return (new Date(cyear, 2, 1)); // 1 march this year
        }
        return cdate; // current date
    }
};